function getRest(value, base) {
  return value % base;
}
function getDuration(durationInSeconds) {
  var totalSeconds = Math.round(durationInSeconds);
  var fullHours = totalSeconds / (60 * 60);
  var hours = Math.floor(fullHours);
  var fullMinutes = Math.floor(totalSeconds / 60);
  var minutes = hours ? getRest(fullMinutes, 60) : fullMinutes;
  var seconds = getRest(totalSeconds, 60);
  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    // round full hours to single decimal place
    fullHours: Math.round(fullHours * 10) / 10,
    fullMinutes: fullMinutes
  };
}
export default getDuration;